import { render, staticRenderFns } from "./Rtos.vue?vue&type=template&id=470f9fd3&"
import script from "./Rtos.vue?vue&type=script&lang=js&"
export * from "./Rtos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports